import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserMandantFacilitiesService } from '@core/services/user-mandant-facilities.service';
import { Observable } from 'rxjs';
import { ActionBarAction } from '@features/documents/document-tab/document-tab.component';
import { ActionBarOptions } from '@shared/components/atoms/actions/action-bar-options.model';

@Component({
  selector: 'xt-portal-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.scss'],
    standalone: false
})
export class ActionsComponent implements OnInit {
  @Input() actionOptions: ActionBarOptions;
  @Input() actionBarActions: ActionBarAction[];
  @Input() dataCy: string;

  @Output() editHandler = new EventEmitter();
  @Output() deleteHandler = new EventEmitter();
  @Output() downloadHandler = new EventEmitter();
  @Output() shareHandler = new EventEmitter();
  @Output() actionHandler = new EventEmitter();

  actionBarActionsList = [];

  isShareActionEnabled$: Observable<boolean>;
  shareActionTooltip$: Observable<string>;

  constructor(
    private userMandantFacilitiesService: UserMandantFacilitiesService,
  ) {
    this.isShareActionEnabled$ =
      this.userMandantFacilitiesService.hasActiveFacilities$;
    this.shareActionTooltip$ =
      this.userMandantFacilitiesService.tooltipDisabledSharing$;
  }

  ngOnInit() {
    this.actionBarActionsList = this.actionBarActions;
  }

  /**
   * emits event on click of edit-icon
   *
   */
  edit() {
    this.editHandler.emit();
  }

  /**
   * emits event on click of delete-icon
   *
   */
  delete() {
    this.deleteHandler.emit();
  }

  /**
   * emits event on click of delete-icon
   *
   */
  download() {
    this.downloadHandler.emit();
  }

  /**
   * emits event on click of share-icon
   *
   */
  share() {
    this.isShareActionEnabled$.subscribe(
      (isEnabled) => isEnabled && this.shareHandler.emit(),
    );
  }

  action(action: string) {
    if (action === 'share') {
      this.isShareActionEnabled$.subscribe(
        (isEnabled) => isEnabled && this.actionHandler.emit(action),
      );
    } else {
      this.actionHandler.emit(action);
    }
  }
}
